import axios, { AxiosInstance } from "axios";

const resolveApiBaseUrl = (url?: string): string => {
  const fallback = "https://localhost:7184/api";
  const raw = (url || fallback).trim().replace(/\/+$/, "");
  return raw.toLowerCase().endsWith("/api") ? raw : `${raw}/api`;
};

const API_BASE_URL = resolveApiBaseUrl(process.env.REACT_APP_API_BASE_URL);

export const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { Accept: "application/json" },
});
